<app-dialog [size]="DialogSize.SMALL">
  <app-dialog-header dataSelector="contact-support-title">Contact Support</app-dialog-header>

  <form [formGroup]="form" class="contact-support">
    @if (destination(); as destinationAddress) {
      <p class="contact-support__destination" dataSelector="contact-support-destination">
        Your message will be sent to <span class="contact-support__destination-address">{{ destinationAddress }}</span>
      </p>
    }

    <div class="form-group">
      <label class="contact-support__label" for="contact-support-name">Name</label>
      <!-- Read-only by design: the server derives the sender from the verified session, so an
           editable value would be silently ignored. -->
      <input
        id="contact-support-name"
        dataSelector="contact-support-name"
        class="form-input"
        type="text"
        readonly
        [value]="data.name"
      />
    </div>

    <div class="form-group">
      <label class="contact-support__label" for="contact-support-email">Email</label>
      <input
        id="contact-support-email"
        dataSelector="contact-support-email"
        class="form-input"
        type="email"
        readonly
        [value]="data.email"
      />
      <p class="contact-support__hint">Your firm will reply to this address.</p>
    </div>

    <div class="form-group">
      <label class="contact-support__label" for="contact-support-description">How can we help?</label>
      <textarea
        id="contact-support-description"
        [attr.aria-describedby]="remaining <= 500 ? 'contact-support-remaining' : null"
        dataSelector="contact-support-description"
        class="form-input contact-support__description"
        formControlName="description"
        rows="6"
        [maxlength]="maxLength"
      ></textarea>
      <app-input-error-hint [control]="descriptionControl" />
      @if (remaining <= 500) {
        <p id="contact-support-remaining" aria-live="polite" class="contact-support__hint" dataSelector="contact-support-remaining">
          {{ remaining }} characters remaining
        </p>
      }
    </div>
  </form>

  <app-dialog-footer [showCancel]="false">
    <button andButton color="ghost" dataSelector="contact-support-cancel" type="button" (click)="close()">Cancel</button>

    <button
      andButton
      color="primary"
      dataSelector="contact-support-send"
      type="button"
      [isLoading]="isSubmitting()"
      (click)="submit()"
    >
      Send
    </button>
  </app-dialog-footer>
</app-dialog>
